<template>
  <div class="dashboard-item flex-column">
    <div class="dashboard-item-val d-flex">
      <div class="flex-grow-1">{{ val }}</div>
      <el-image :src="src" style="width: 48px;height: 48px" />
    </div>
    <div class="d-flex">
      <div class="dashboard-item-desc">
        {{ desc }}
      </div>
      <div class="flex-1"></div>
    </div>
  </div>
</template>

<script>

export default {
  props: ["item", "desc", "val", "src", "responseTime", "staffMessage"]
};
</script>

<style scoped>

</style>
